import styled from 'styled-components';
import { Link } from 'react-router';

export const BrandLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  min-width: 0;
  flex-shrink: 1;

  &:hover {
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 2px solid #2c5282;
    outline-offset: 2px;
    border-radius: 8px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  min-width: 0;

  @media (max-width: 768px) {
    align-items: center;
    gap: 0.75rem;
  }
`;

export const Avatar = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: #e9eef5;
  background-size: cover;
  background-position: center;
  flex: 0 0 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
  }
`;


export const LogoBox = styled.div`
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #2c426b 0%, #23395d 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 16px 0 rgba(16, 42, 67, 0.1);
  margin-right: 2px;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    border-radius: 10px;
  }
`;

export const LogoText = styled.span`
  color: #fff;
  font-size: 19px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  letter-spacing: 0;
  line-height: 1;
`;

export const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;

export const MainTitle = styled.span`
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  color: #19334d;
  letter-spacing: 0;
  margin-bottom: 0;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubTitle = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: clamp(0.75rem, 2vw, 0.85rem);
  color: #8a94a6;
  margin-top: 0;
  line-height: 1.1;
`;

export const HeaderWrapper = styled.div`
  background-color: #fff;
  width: 100%;
  box-shadow: 0 4px 14px rgba(16, 42, 67, 0.06);
  border-bottom: 1px solid #e3e8f0;
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const HeaderContainer = styled.header`
  width: 100%;
  max-width: min(980px, 100%);
  margin: 0 auto;
  padding: 0.85rem clamp(1rem, 3vw, 1.5rem);
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const LogoIcon = styled.div`
  width: 48px;
  height: 48px;
  background: #0b1e51;
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 700;
  margin-right: 1.25rem;
  box-shadow: 0 2px 8px 0 rgba(16, 42, 67, 0.08);
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const LeftArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  gap: 0.35rem;
`;

export const RightArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 1;
  min-width: 0;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    gap: 10px;
  }
`;

export const UserMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  flex: 1 1 auto;

  @media (max-width: 768px) {
    flex: 1 1 auto;
    min-width: 0;
  }
`;

export const PillRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const ActionCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

export const AvatarWrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #6d28d9;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 6px 18px;
  font-weight: 700;
  font-size: 0.8rem;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(109, 40, 217, 0.25);
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 0.72rem;
    border-radius: 10px;
    gap: 6px;
    box-shadow: 0 4px 12px rgba(109, 40, 217, 0.2);
  }
`;

export const MenuButton = styled.button<{ $open?: boolean }>`
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border: 1px solid #e3e8f0;
  border-radius: 10px;
  background: #fff;
  color: #19334d;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }

  @media (max-width: 768px) {
    display: inline-flex;
  }
`;

export const MobileNavPanel = styled.nav<{ $open?: boolean }>`
  display: none;

  @media (max-width: 768px) {
    display: ${({ $open }) => ($open ? 'block' : 'none')};
    width: 100%;
    margin-top: 0.35rem;
    padding: 0.5rem;
    border: 1px solid #e3e8f0;
    border-radius: 12px;
    background: #f8fafc;
  }
`;

export const DesktopTabs = styled.div`
  display: block;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Pill = styled.span`
  background: #7b2639;
  color: #fff;
  border-radius: 999px;
  padding: 5px 10px;
  font-weight: 700;
  font-size: 0.72rem;
`;

export const OutlinePill = styled.span`
  background: #fff;
  color: #223046;
  border: 1.5px solid #e3e8f0;
  border-radius: 999px;
  padding: 5px 10px;
  font-weight: 600;
  font-size: 0.72rem;
`;

export const UserBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UserName = styled.span`
  font-weight: 700;
  color: #223046;
  font-size: clamp(0.95rem, 2.4vw, 1.2rem);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;

  @media (max-width: 768px) {
    max-width: min(200px, 55vw);
  }
`;

export const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #222;
  letter-spacing: 0.5px;
`;

export const Subtitle = styled.div`
  font-size: 1rem;
  color: #8a94a6;
  font-weight: 500;
  margin-top: 0.1rem;
`;
